// extracted by mini-css-extract-plugin
export default {"text":"Landing_text__jm9Mc","container":"Landing_container__PDcog","headline":"Landing_headline__z2zVp","subHeadline":"Landing_subHeadline__1ApfA"};